import { BrowserRouter } from 'react-router';
import AppRoutes from './router/routes';
import TreeDataProvider from '@/contexts/TreeDataProvider';
import './styles/app.scss';

function App() {
    return (
        <TreeDataProvider>
            <BrowserRouter basename="/mujerymemoria">
                <AppRoutes />
            </BrowserRouter>
        </TreeDataProvider>
    );
}

export default App;
